/**
 * Largest-remainder (Hamilton) rounding so integer percents sum to 100
 * when counts partition the total.
 */
export function distributePercents(counts: number[], total: number): number[] {
  if (total === 0) {
    return counts.map(() => 0)
  }

  const exactPercents = counts.map((count) => (count / total) * 100)
  const flooredPercents = exactPercents.map((value) => Math.floor(value))
  let remainingPoints = 100 - flooredPercents.reduce((sum, value) => sum + value, 0)

  const rankedIndexes = exactPercents
    .map((value, index) => ({
      index,
      remainder: value - flooredPercents[index],
    }))
    .sort((left, right) => {
      if (right.remainder !== left.remainder) {
        return right.remainder - left.remainder
      }
      return left.index - right.index
    })

  const result = [...flooredPercents]
  for (let rank = 0; rank < remainingPoints; rank += 1) {
    result[rankedIndexes[rank].index] += 1
  }

  return result
}
